import api from "@helpers/api";
import { EmployeeAssignDeskOrBedType } from "@type/inventory/employee";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_BASE_URL}${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE}/api/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_VERSION}/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_TYPE}/inventory/employees`;

export const getEmployees = async (query: any) => {
  const _query = {
    ...query,
    search: !!query.search ? query.search : null,
  };
  const res = await api.get(`${apiEndPoint}`, {
    params: _query,
  });

  return res;
};

export const getEmployee = async (id: number | string) => {
  const res = await api.get(`${apiEndPoint}/${id}`);

  return res;
};

export const getEmployeeGeneralInfo = async (id: number | string) => {
  const res = await api.get(`${apiEndPoint}/${id}`);

  return res;
};

export const getEmployeeAssets = async (id: number | string, query: any) => {
  const res = await api.get(`${apiEndPoint}/${id}/assets`, {
    params: query,
  });

  return res;
};

export const assignDeskOrBed = async (
  id: string | number,
  data: EmployeeAssignDeskOrBedType,
) => {
  const res = await api.post(`${apiEndPoint}/${id}/assign/address`, {
    ...data,
  });

  return res;
};
